module.exports = __webpack_public_path__ + "static/media/open.acdce5ac.jpg";